/**
 * The words of what a FAIL does: the list leaves the order, and what today
 * does with it — Stop list or Complete list (23/10/2026: the only choice
 * under the FAIL chip; "List comes back" is hidden).
 * For Media Devoted | Created By Ciro Autiero
 */
export const failModeWord = (failMode: string) => (failMode === 'STOP_FOR_DAY' ? 'stop list' : 'complete list');

export const failModeNote = (failMode: string) => (failMode === 'STOP_FOR_DAY' ? 'the rest of today is skipped' : 'today still finishes');

export const HINTS = {
  failMode:
    "A FAIL takes the list out of this container's order: the group moves to its next list the next day, and the list stays out until Reset pool (Live tab). When a FAIL happens is up to the conditions and their It happened on row above. Stop list = today's later drops to that list are skipped; Complete list = today still sends them.",
} as const;
